// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"287":"ece831ff","345":"3ec8789d","492":"0fd1b86d","588":"0131a9a4","671":"ed81da84","686":"55273b81","849":"f5a200d6","864":"a44ffe94","880":"db0153a2","961":"64790b56"}[chunkId] + ".chunk.css";
};